export default "__VITE_ASSET__Bm6joTsD__"